exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh3[data-v-0629f004] {\n  margin: 40px 0 0;\n}\nul[data-v-0629f004] {\n  list-style-type: none;\n  padding: 0;\n}\nli[data-v-0629f004] {\n  display: inline-block;\n  margin: 0 10px;\n}\na[data-v-0629f004] {\n  color: #42b983;\n}\n", ""]);

// exports
